/**
 * DecorativeElements Component
 * SVG decorative sports elements for the create challenge page
 */

import React from 'react';
import { View, Platform } from 'react-native';
import Svg, { Circle, Path, Ellipse, Line, Rect, Polygon } from 'react-native-svg';
import { decorativeElementsStyles as styles } from './DecorativeElements.styles';

export const DecorativeElements: React.FC = () => {
  return (
    <View style={styles.decorativeElements}>
      {/* Soccer Ball */}
      <View style={[styles.sportsDrawing, { top: '10%', left: '10%' }]}>
        <Svg width={styles.iconSize.width} height={styles.iconSize.height} viewBox="0 0 40 40">
          <Circle cx="20" cy="20" r="18" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Path d="M8 20 Q20 8 32 20 Q20 32 8 20" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M20 8 Q32 20 20 32 Q8 20 20 8" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Basketball */}
      <View style={[styles.sportsDrawing, { top: '15%', right: '15%' }]}>
        <Svg width={styles.iconSize.width} height={styles.iconSize.height} viewBox="0 0 40 40">
          <Circle cx="20" cy="20" r="18" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Line x1="20" y1="2" x2="20" y2="38" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Line x1="2" y1="20" x2="38" y2="20" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M2 20 Q20 5 38 20" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M2 20 Q20 35 38 20" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Tennis Ball */}
      <View style={[styles.sportsDrawing, { top: '25%', left: '5%' }]}>
        <Svg width={styles.iconSize.width} height={styles.iconSize.height} viewBox="0 0 35 35">
          <Circle cx="17.5" cy="17.5" r="16" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Path d="M5 17.5 Q17.5 5 30 17.5 Q17.5 30 5 17.5" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5"/>
        </Svg>
      </View>

      {/* Football */}
      <View style={[styles.sportsDrawing, { top: '35%', right: '8%' }]}>
        <Svg width={Platform.OS === 'web' ? 65 : 45} height={Platform.OS === 'web' ? 45 : 30} viewBox="0 0 45 30">
          <Ellipse cx="22.5" cy="15" rx="20" ry="13" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Line x1="22.5" y1="2" x2="22.5" y2="28" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Line x1="10" y1="15" x2="35" y2="15" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Hockey Stick & Puck */}
      <View style={[styles.sportsDrawing, { top: '45%', left: '12%' }]}>
        <Svg width="40" height="40" viewBox="0 0 40 40">
          <Path d="M5 35 L5 15 Q5 10 10 10 L30 10" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="3"/>
          <Circle cx="32" cy="32" r="4" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Goal Posts */}
      <View style={[styles.sportsDrawing, { top: '55%', right: '20%' }]}>
        <Svg width="40" height="35" viewBox="0 0 40 35">
          <Rect x="5" y="25" width="30" height="2" fill="rgba(255,255,255,0.15)"/>
          <Rect x="5" y="5" width="2" height="20" fill="rgba(255,255,255,0.15)"/>
          <Rect x="33" y="5" width="2" height="20" fill="rgba(255,255,255,0.15)"/>
          <Rect x="5" y="5" width="30" height="2" fill="rgba(255,255,255,0.15)"/>
        </Svg>
      </View>

      {/* Whistle */}
      <View style={[styles.sportsDrawing, { top: '65%', left: '8%' }]}>
        <Svg width="35" height="25" viewBox="0 0 35 25">
          <Ellipse cx="17" cy="12" rx="12" ry="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Circle cx="12" cy="12" r="2" fill="rgba(255,255,255,0.15)"/>
          <Line x1="29" y1="12" x2="32" y2="12" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
        </Svg>
      </View>

      {/* Trophy */}
      <View style={[styles.sportsDrawing, { top: '75%', right: '12%' }]}>
        <Svg width={Platform.OS === 'web' ? 55 : 35} height={Platform.OS === 'web' ? 60 : 40} viewBox="0 0 35 40">
          <Rect x="12" y="15" width="11" height="15" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="1"/>
          <Rect x="10" y="30" width="15" height="3" fill="rgba(255,255,255,0.15)"/>
          <Rect x="8" y="33" width="19" height="2" fill="rgba(255,255,255,0.15)"/>
          <Path d="M12 15 Q17.5 5 23 15" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Circle cx="7" cy="20" r="3" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Circle cx="28" cy="20" r="3" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Dumbbell */}
      <View style={[styles.sportsDrawing, { top: '85%', left: '15%' }]}>
        <Svg width="45" height="20" viewBox="0 0 45 20">
          <Rect x="2" y="6" width="6" height="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="1"/>
          <Rect x="37" y="6" width="6" height="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="1"/>
          <Rect x="8" y="9" width="29" height="2" fill="rgba(255,255,255,0.15)"/>
        </Svg>
      </View>

      {/* Medal */}
      <View style={[styles.sportsDrawing, { top: '20%', left: '85%' }]}>
        <Svg width="25" height="35" viewBox="0 0 25 35">
          <Circle cx="12.5" cy="25" r="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Path d="M7 8 L12.5 17 L18 8" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Circle cx="12.5" cy="25" r="4" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Stopwatch */}
      <View style={[styles.sportsDrawing, { top: '40%', left: '90%' }]}>
        <Svg width="30" height="35" viewBox="0 0 30 35">
          <Circle cx="15" cy="20" r="12" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Rect x="12" y="5" width="6" height="4" fill="rgba(255,255,255,0.15)"/>
          <Line x1="15" y1="20" x2="15" y2="12" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Line x1="15" y1="20" x2="20" y2="20" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Baseball */}
      <View style={[styles.sportsDrawing, { top: '5%', left: '50%' }]}>
        <Svg width={styles.iconSize.width} height={styles.iconSize.height} viewBox="0 0 35 35">
          <Circle cx="17.5" cy="17.5" r="16" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Path d="M5 10 Q10 8 15 10 Q20 12 25 10 Q30 8 35 10" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M5 25 Q10 27 15 25 Q20 23 25 25 Q30 27 35 25" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Volleyball */}
      <View style={[styles.sportsDrawing, { top: '30%', left: '50%' }]}>
        <Svg width="38" height="38" viewBox="0 0 38 38">
          <Circle cx="19" cy="19" r="17" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Path d="M19 2 Q32 10 19 19 Q6 10 19 2" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M19 36 Q32 28 19 19 Q6 28 19 36" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Line x1="19" y1="2" x2="19" y2="36" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Ping Pong Paddle */}
      <View style={[styles.sportsDrawing, { top: '50%', left: '50%' }]}>
        <Svg width="25" height="40" viewBox="0 0 25 40">
          <Ellipse cx="12.5" cy="12" rx="10" ry="10" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Rect x="10" y="22" width="5" height="15" fill="rgba(255,255,255,0.15)"/>
          <Circle cx="12.5" cy="12" r="6" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Badminton Shuttlecock */}
      <View style={[styles.sportsDrawing, { top: '70%', left: '50%' }]}>
        <Svg width="20" height="35" viewBox="0 0 20 35">
          <Circle cx="10" cy="28" r="4" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="1"/>
          <Path d="M6 28 L10 5 L14 28" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M4 28 L10 8 L16 28" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M2 28 L10 12 L18 28" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Boxing Glove */}
      <View style={[styles.sportsDrawing, { top: '15%', left: '30%' }]}>
        <Svg width="35" height="30" viewBox="0 0 35 30">
          <Path d="M5 20 Q5 10 15 10 Q25 10 30 15 Q35 20 30 25 Q25 28 15 25 Q5 25 5 20" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Rect x="2" y="18" width="8" height="8" rx="4" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Swimming Goggles */}
      <View style={[styles.sportsDrawing, { top: '60%', left: '30%' }]}>
        <Svg width="40" height="20" viewBox="0 0 40 20">
          <Circle cx="12" cy="10" r="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Circle cx="28" cy="10" r="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Line x1="20" y1="10" x2="20" y2="10" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Path d="M4 10 Q2 8 0 10" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Path d="M36 10 Q38 8 40 10" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
        </Svg>
      </View>

      {/* Bowling Pin */}
      <View style={[styles.sportsDrawing, { top: '80%', left: '70%' }]}>
        <Svg width="15" height="35" viewBox="0 0 15 35">
          <Path d="M7.5 5 Q10 5 10 8 Q10 12 8 15 Q9 20 9 25 Q9 30 7.5 30 Q6 30 6 25 Q6 20 7 15 Q5 12 5 8 Q5 5 7.5 5" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Circle cx="7.5" cy="8" r="2" fill="rgba(255,255,255,0.15)"/>
        </Svg>
      </View>

      {/* Golf Ball & Tee */}
      <View style={[styles.sportsDrawing, { top: '25%', left: '70%' }]}>
        <Svg width="25" height="30" viewBox="0 0 25 30">
          <Circle cx="12.5" cy="10" r="8" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Circle cx="11" cy="8" r="0.5" fill="rgba(255,255,255,0.15)"/>
          <Circle cx="14" cy="8" r="0.5" fill="rgba(255,255,255,0.15)"/>
          <Circle cx="12.5" cy="12" r="0.5" fill="rgba(255,255,255,0.15)"/>
          <Path d="M10 25 L12.5 18 L15 25" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Line x1="8" y1="25" x2="17" y2="25" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
        </Svg>
      </View>

      {/* Skateboard */}
      <View style={[styles.sportsDrawing, { top: '45%', left: '70%' }]}>
        <Svg width="45" height="15" viewBox="0 0 45 15">
          <Path d="M5 7.5 Q10 5 20 5 Q35 5 40 7.5 Q35 10 20 10 Q10 10 5 7.5" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Circle cx="8" cy="7.5" r="3" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Circle cx="37" cy="7.5" r="3" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Dart */}
      <View style={[styles.sportsDrawing, { top: '90%', left: '50%' }]}>
        <Svg width="35" height="8" viewBox="0 0 35 8">
          <Line x1="2" y1="4" x2="28" y2="4" stroke="rgba(255,255,255,0.15)" strokeWidth="2"/>
          <Polygon points="28,4 32,2 32,6" fill="rgba(255,255,255,0.15)"/>
          <Path d="M2 2 L5 4 L2 6" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Path d="M8 2 L11 4 L8 6" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>

      {/* Cycling Helmet */}
      <View style={[styles.sportsDrawing, { top: '5%', right: '5%' }]}>
        <Svg width="35" height="25" viewBox="0 0 35 25">
          <Path d="M5 20 Q5 8 17.5 8 Q30 8 30 20" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.2)" strokeWidth="2"/>
          <Line x1="10" y1="15" x2="25" y2="15" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
          <Circle cx="17.5" cy="12" r="2" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
        </Svg>
      </View>
    </View>
  );
};

